const currentEnv = `${process.env.REACT_APP_ENVIRONMENT}`;

export const getTokenExID = () => {
  const tokenExId = {
    QA: "8933712891600676",
    PRODUCTION: "2648141839377514",
    STAGING: "2648141839377514",
    DEVELOPMENT: "8933712891600676",
  };
  return tokenExId[currentEnv];
};
export const getTokenExSecretKey = () => {
  const tokenExSecretKey = {
    QA: "HD5tkxH5bDC3j8tAN0mpP05oXFRTkdDtjJMvZOhy",
    PRODUCTION: "dqdxcNgXQj1rKdG3frKZ3439BHiVcHWyVlJ35O5g",
    STAGING: "dqdxcNgXQj1rKdG3frKZ3439BHiVcHWyVlJ35O5g",
    DEVELOPMENT: "HD5tkxH5bDC3j8tAN0mpP05oXFRTkdDtjJMvZOhy",
  };
  return tokenExSecretKey[currentEnv];
};
export const getTokenExScheme = () => {
  return "sixANTOKENfour";
};
export const getTokenExApiKey = () => {
  const tokenExApiKey = {
    QA: "yKxojFnmhrfhAiKAzk1o1CFHHxwH9LjCNYMXFFjS",
    PRODUCTION: "QmyH1ApFZ1Y4VCKS0bkXFhJJvFbxXgBCo9AAmDt9",
    STAGING: "QmyH1ApFZ1Y4VCKS0bkXFhJJvFbxXgBCo9AAmDt9",
    DEVELOPMENT: "yKxojFnmhrfhAiKAzk1o1CFHHxwH9LjCNYMXFFjS",
  };
  return tokenExApiKey[currentEnv];
};
export const getTokenExJsURL = () => {
  const tokenExJsURL = {
    QA: "https://test-htp.tokenex.com/Iframe/Iframe-v3.min.js",
    PRODUCTION: "https://htp.tokenex.com/Iframe/Iframe-v3.min.js",
    STAGING: "https://htp.tokenex.com/Iframe/Iframe-v3.min.js",
    DEVELOPMENT: "https://test-htp.tokenex.com/Iframe/Iframe-v3.min.js",
  };
  return tokenExJsURL[currentEnv];
};

export const getPaypalHostUrl = () => {
  const paypalHostUrl = {
    QA: "https://api-m.sandbox.Paypal.com",
    PRODUCTION: "https://api-m.paypal.com",
    STAGING: "https://api-m.paypal.com",
    DEVELOPMENT: "https://api-m.sandbox.Paypal.com",
  };
  return paypalHostUrl[currentEnv];
};
export const getPaypalClientId = () => {
  const paypalClientId = {
    QA: "AXPHSv-ENfFSkuL8Jp7sScQuuhPfAxPHjC_cikjbTkoCIG9dvam1ifZBG5ScFICou_Q3LpLtZrN1_16m",
    PRODUCTION:
      "AXwFUN5tdIQ4JCQ72S1-9OhJvYS4RIYJIYrPbe-u9EWxtBvcsbxIOIWpqPwcK22LvOglEZ9WK0_dMhFW",
    STAGING:
      "AXwFUN5tdIQ4JCQ72S1-9OhJvYS4RIYJIYrPbe-u9EWxtBvcsbxIOIWpqPwcK22LvOglEZ9WK0_dMhFW",
    DEVELOPMENT:
      "AXPHSv-ENfFSkuL8Jp7sScQuuhPfAxPHjC_cikjbTkoCIG9dvam1ifZBG5ScFICou_Q3LpLtZrN1_16m",
  };
  return paypalClientId[currentEnv];
};
export const getPaypalClientSecret = () => {
  const paypalClientSecret = {
    QA: "EFCsh1Le4rG3mY7lrnEEk5N5EsZtgGS4SA88v8xYzWzgs8odbrxs3nTTJkcsZgClV-JRwPzPE2CW1C-w",
    PRODUCTION:
      "ECNGCbiRQrf-l8JVdKldC61OkO8YtN8HzOPSHwEFHsTdLl0oBpmdhXJYTkA_tsWPHLPk4K-D-vCgiMsU",
    STAGING:
      "ECNGCbiRQrf-l8JVdKldC61OkO8YtN8HzOPSHwEFHsTdLl0oBpmdhXJYTkA_tsWPHLPk4K-D-vCgiMsU",
    DEVELOPMENT:
      "EFCsh1Le4rG3mY7lrnEEk5N5EsZtgGS4SA88v8xYzWzgs8odbrxs3nTTJkcsZgClV-JRwPzPE2CW1C-w",
  };
  return paypalClientSecret[currentEnv];
};

export const getChargBeeSiteName = () => {
  const chargeBeeSiteName = {
    QA: "insightfultraits-test",
    PRODUCTION: "insightfultraits",
    STAGING: "insightfultraits",
    DEVELOPMENT: "insightfultraits-test",
  };
  return chargeBeeSiteName[currentEnv];
};
export const getChargBeeUserName = () => {
  const chargBeeUserName = {
    QA: "test_TIVZzGq8hG8n0rGsVe3dSyOrjlvOxI9cu",
    PRODUCTION: "live_3MIfAzyQpj8X61McdWcmpN4Chzo8GAaTx",
    STAGING: "live_3MIfAzyQpj8X61McdWcmpN4Chzo8GAaTx",
    DEVELOPMENT: "test_TIVZzGq8hG8n0rGsVe3dSyOrjlvOxI9cu",
  };
  return chargBeeUserName[currentEnv];
};

export const paymentMode = {
  NONE: 0,
  CHARGEBEE: 1,
  PAYPAL: 2,
  APPLEPAY: 3,
  GOOGLEPAY: 4,
};
